import React, { useEffect, useState } from 'react';
import { Row, Col, Select, message } from 'antd';
import { PlusOutlined, UserOutlined, AppstoreOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Modal, Button } from '../../../design-system';
import nodeAPI from '../../../service/ApiServiceNode';
import ClientModal from '../Clients/ClientModal';
import ClientProjectForm from './ClientProjectForm';
import InternalProjectForm from './InternalProjectForm';
import './project-creation-modal.scss';

const ProjectCreationModal = ({ open, onClose }) => {
    const [client, setClient] = useState(null);
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addingClient, setAddingClient] = useState(false);
    const [projectType, setProjectType] = useState(null);

    useEffect(() => {
        if (!open) {
            setClient(null);
            setProjectType(null);
            setAddingClient(false);
            return;
        }
        let active = true;
        setLoading(true);
        nodeAPI.get('/project/clients?view=dropdown').then(response => {
            const data = response.data?.data || response.data || {};
            if (active) setClients(data.data || data.clients || []);
        }).catch(() => {
            if (active) message.error('Unable to load clients. Please try again.');
        }).finally(() => {
            if (active) setLoading(false);
        });
        return () => { active = false; };
    }, [open]);

    const handleClose = () => {
        setClient(null);
        setProjectType(null);
        setAddingClient(false);
        onClose();
    };

    if (projectType === 'INTERNAL') {
        return <InternalProjectForm open={open} onClose={handleClose} onBack={() => setProjectType(null)} />;
    }
    if (projectType) {
        return <ClientProjectForm key={projectType} open={open} onClose={handleClose}
            onBack={() => setProjectType(null)} projectType={projectType} initialClient={client} />;
    }

    const options = [
        { type: 'CONFIRMED', label: 'Confirmed Project', icon: <CheckCircleOutlined />, className: 'client-icon' },
        { type: 'LEAD', label: 'Lead Project', icon: <UserOutlined />, className: 'client-icon' },
        { type: 'INTERNAL', label: 'Internal Project', icon: <AppstoreOutlined />, className: 'internal-icon' }
    ];

    return <>
        <Modal visible={open && !addingClient} onClose={handleClose} width="medium" className="project-creation-modal">
            <Modal.Header title="ADD PROJECT" />
            <Modal.Body>
                {!client ? (
                    <>
                        <div style={{ display: 'flex', gap: 12 }}>
                            <Select aria-label="Select a client" showSearch placeholder="Search and select a client"
                                loading={loading} style={{ flex: 1 }} optionFilterProp="label"
                                options={clients.map(item => ({ value: item.id, label: item.name }))}
                                notFoundContent={loading ? 'Loading clients…' : 'Client not in the list? Click the + button to add a new client.'}
                                onChange={id => setClient(clients.find(item => item.id === id))} />
                            <Button variant="secondary" icon={<PlusOutlined />} aria-label="Add new client"
                                onClick={() => setAddingClient(true)} />
                        </div>
                        <p>Client not in the list? Click the + button to add a new client.</p>
                    </>
                ) : (
                    <>
                        <p style={{ textAlign: 'center', marginBottom: 12 }}>Client: <strong>{client.name}</strong></p>
                        <h3 className="select-type-title">SELECT PROJECT TYPE</h3>
                        <Row gutter={24} className="options-container">
                            {options.map(option => <Col span={8} key={option.type}>
                                <button type="button" className="option-card" style={{ width: '100%', background: 'white' }}
                                    onClick={() => setProjectType(option.type)}>
                                    <div className="card-content">
                                        <div className={`icon-wrapper ${option.className}`}>{option.icon}</div>
                                        <h3>{option.label}</h3>
                                    </div>
                                </button>
                            </Col>)}
                        </Row>
                        <Button variant="secondary" size="small" onClick={() => setClient(null)} style={{ marginTop: 20 }}>Change Client</Button>
                    </>
                )}
            </Modal.Body>
        </Modal>
        <ClientModal visible={open && addingClient} mode="add" onClose={() => setAddingClient(false)}
            onSuccess={created => {
                setClients(previous => [...previous, created]);
                setClient(created);
                setAddingClient(false);
            }} />
    </>;
};

export default ProjectCreationModal;
